import React from "react";
import UserBadge from "../user-badge";
import ThemeToggle from "../theme-toggle";
import { UserProfile } from "../../types";
import { getAppStyles } from "../../theme/app-theme";
import "./styles.scss";
import icons from "../../assets/icons.png";
import logosLight from "../../assets/right_top_logos_black.png";
import logosDark from "../../assets/right_top_logos.png";

interface HeaderProps {
    user: UserProfile;
    routeBack?: string;
    isDarkMode?: boolean;
    onToggleTheme?: () => void;
}

const Header: React.FC<HeaderProps> = ({
    user,
    routeBack,
    isDarkMode = false,
    onToggleTheme,
}) => {
    const styles = getAppStyles(isDarkMode);
    const logos = isDarkMode ? logosDark : logosLight;

    return (
        <header style={styles.header}>
            {routeBack != "" && routeBack != null && routeBack != undefined ? (
                <div style={styles.headerText} className="header-text">
                    <img src={logos} style={{ width: "350px", height: "55px" }} alt="" />
                </div>
            ) : (
                <h2 style={styles.headerText} className="header-text">
                    Aplicações e sistemas
                </h2>
            )}

            <div className="header-icons-mobile" style={{ marginLeft: "40px" }}>
                <img src={icons} style={{ width: "100px", height: "32px" }} alt="" />
            </div>

            <div className="header-actions">
                {onToggleTheme && (
                    <ThemeToggle isDarkMode={isDarkMode} onToggle={onToggleTheme} />
                )}
                <UserBadge
                    user={user}
                    isDarkMode={isDarkMode}
                    propStyles={{ marginRight: "40px" }}
                />
            </div>
        </header>
    );
};

export default Header;
